import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKey as aansluitingQueryKey } from '../../aansluiting/contractinstellingen/hooks/useProjectbetrokkenenSearch'
import { queryKey as hoofdleidingQueryKey } from '../../hoofdleiding/contractinstellingen/hooks/useProjectbetrokkenenSearch'
import { useAlerts } from '../../theme/hooks/useAlerts'
import { queryKey as valuelistAansluitingQueryKey } from '../../valuelists/hooks/useAansluitingValuelists'
import { queryKey as hoofdleidingContextListsQueryKey } from '../../valuelists/hooks/useHoofdleidingContextLists'
import { queryKey as hoofdleidingOrganisationListsQueryKey } from '../../valuelists/hooks/useHoofdleidingOrganisationLists'
import { createProjectbetrokkene } from '../services/createProjectbetrokkene'

export { useCreateProjectbetrokkene }

const useCreateProjectbetrokkene = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: createProjectbetrokkene,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [aansluitingQueryKey] })
      queryClient.invalidateQueries({ queryKey: [hoofdleidingQueryKey] })
      queryClient.invalidateQueries({
        queryKey: [valuelistAansluitingQueryKey],
      })
      queryClient.invalidateQueries({
        queryKey: hoofdleidingOrganisationListsQueryKey,
      })
      queryClient.invalidateQueries({
        queryKey: hoofdleidingContextListsQueryKey,
      })
      successAlert('Projectbetrokkene succesvol toegevoegd')
    },
  })
}
